import React from 'react';
import { Container, Stack } from '@chakra-ui/react';

import HeaderSection from './HeaderSection';
import Blocks from './Blocks';
import { responsive } from '../contexts/responsive';

export { query } from './portalQuery';

const ProfileHomePage = (props) => {
  return (
    <Container as={Stack} py={responsive(4, 8)} spacing="1em">
      <HeaderSection {...props} />
      <Blocks {...props} />
    </Container>
  )
};

export default ProfileHomePage;
